import JaJpJSON from '../language/ja-JP.json'
import EnUsJSON from '../language/en-US.json'
import ZhTwJSON from '../language/zh-TW.json'

export function getLanguage() {
  const storageLanuage = localStorage.getItem('language')
  if (storageLanuage) return storageLanuage

  if (navigator.language.includes('ja') || navigator.language.includes('jp')) {
    return 'ja_JP'
  }

  if (navigator.language.includes('en')) {
    return 'en_US'
  }

  if (
    navigator.language.includes('hk') ||
    navigator.language.includes('zh') ||
    navigator.language.includes('hant')
  ) {
    return 'zh_TW'
  }

  return 'zh_CN'
}

export default function T(languageString) {
  const currentLanguage = getLanguage()

  if (currentLanguage === 'ja_JP') {
    return JaJpJSON[languageString] || languageString
  }

  if (currentLanguage === 'en_US') {
    return EnUsJSON[languageString] || languageString
  }

  if (currentLanguage === 'zh_TW') {
    return ZhTwJSON[languageString] || languageString
  }

  // current languageString is zh_CN
  return languageString
}
